import { render, staticRenderFns } from "./modalGuiaGenerada.vue?vue&type=template&id=038409b7&scoped=true&"
import script from "./modalGuiaGenerada.vue?vue&type=script&lang=js&"
export * from "./modalGuiaGenerada.vue?vue&type=script&lang=js&"
import style0 from "./modalGuiaGenerada.vue?vue&type=style&index=0&id=038409b7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "038409b7",
  null
  
)

export default component.exports